import styled from '@emotion/styled'

export const Image = styled.img`
  height: 20px;
  margin-right: 4px;
`
